// Descuento gerencial — paso 2 del circuito NSAUTDTO del Clipper (semillas
// "DIOS"). Misma aritmética que descuento, distintas semillas: ver nsautdto.js.
//
// Reemplaza en septiembre de 2026 al algoritmo original, que dependía de la
// fecha y no ataba el código a la sucursal.
//
// El operador ingresa 6 dígitos: los primeros 4 son el código que el Clipper
// le dio al vendedor (completado con ceros a la izquierda si es más corto) y
// los 2 últimos el markup subido en 10 (convención de ofuscación). El markup
// real lo calcula la API al registrar; acá solo se transporta como se tipeó.

import { paso2 } from "../descuento/nsautdto.js";

const separar = (nroSolicitud) => {
  const texto = String(nroSolicitud ?? "").trim();
  if (!/^\d{6}$/.test(texto)) return null;
  return { codigo: parseInt(texto.slice(0, 4), 10), rentabilidad: texto.slice(4) };
};

export function validar({ nroSolicitud, sucursal }) {
  const partes = separar(nroSolicitud);
  if (!partes || partes.codigo < 1) {
    return "Numero incorrecto. Se esperan 6 dígitos";
  }
  if (!sucursal) {
    return "Elegí la sucursal";
  }
  if (paso2(Number(sucursal), partes.codigo, true) === -1) {
    return "El código no corresponde a la sucursal elegida";
  }
  return null;
}

export function calcular({ nroSolicitud, sucursal }) {
  const { codigo, rentabilidad } = separar(nroSolicitud);
  const final = paso2(Number(sucursal), codigo, true);
  if (final === -1) throw new Error("El código no corresponde a la sucursal");

  return {
    codigo: String(final).padStart(4, "0"),
    detalle: {
      codigoPedido: String(codigo).padStart(4, "0"),
      sucursalId: sucursal,
      // valor tipeado, con el +10 todavía puesto: la API lo descuenta
      rentabilidadIngresada: rentabilidad,
    },
  };
}
